var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoomsMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53516 0.625L0.847656 2.75781C0.328125 2.94922 0 3.44141 0 3.98828V10.1406C0 10.6328 0.273438 11.0977 0.710938 11.3164L6.39844 14.1602C6.78125 14.3516 7.19141 14.3516 7.57422 14.1602L13.2617 11.3164C13.6992 11.0977 13.9727 10.6328 13.9727 10.1406V3.98828C13.9727 3.44141 13.6445 2.94922 13.125 2.75781L7.4375 0.625C7.16406 0.515625 6.83594 0.515625 6.53516 0.625ZM7 2.32031L12.25 4.28906V4.31641L7 6.44922L1.75 4.31641V4.28906L7 2.32031ZM7.875 12.0547V7.98047L12.25 6.20312V9.86719L7.875 12.0547Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomsMenuIcon);
export default __webpack_public_path__ + "static/media/RoomsMenuIcon.a874b135.svg";
export { ForwardRef as ReactComponent };